module.exports = __webpack_public_path__ + "static/media/powerpoint.55df49dc.svg";